import { render, staticRenderFns } from "./DashboardItem.vue?vue&type=template&id=030e476c&scoped=true"
import script from "./DashboardItem.vue?vue&type=script&lang=js"
export * from "./DashboardItem.vue?vue&type=script&lang=js"
import style0 from "./DashboardItem.vue?vue&type=style&index=0&id=030e476c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "030e476c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/admin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('030e476c')) {
      api.createRecord('030e476c', component.options)
    } else {
      api.reload('030e476c', component.options)
    }
    module.hot.accept("./DashboardItem.vue?vue&type=template&id=030e476c&scoped=true", function () {
      api.rerender('030e476c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Dashboard/DashboardItem.vue"
export default component.exports